import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';
import { List } from 'immutable';

import Form from '../Form';
import { money } from '../../utils/format';

class LegResultForm extends Form {
    static fieldsValidation = {
        type: [ 'required' ],
        priceType: [ 'required' ],
        place: [ 'numeric' ]
    };

    static propTypes = {
        ...Form.propTypes,
        eachWay: PropTypes.bool
    };

    static defaultProps = {
        ...Form.defaultProps,
        markValid: false,
        eachWay: false,
        bonusList: List()
    };

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { data, eachWay, bonuses, currency, bonusList } = this.props;

        const resultField = this.getField(
            <select label='Result' { ...this.getFieldParameters('type') }>
                <option />
                <option value='won'>Won</option>
                <option value='halfwon'>Half Won</option>
                <option value='lost'>Lost</option>
                <option value='halflost'>Half Lost</option>
                <option value='place'>Place</option>
                <option value='void'>Void</option>
            </select>
        );

        const priceTypeField = this.getField(
            <select label='Price type' { ...this.getFieldParameters('priceType') }>
                <option />
                <option value='bp'>BP</option>
                <option value='ep'>EP</option>
                <option value='fp'>FP</option>
                <option value='sp'>SP</option>
            </select>
        );

        const placeField = this.getField(
            <input
                type='number'
                label='Place'
                { ...this.getFieldParameters('place') }
            />
        );

        const priceField = this.getField(
            <input
                type='text'
                label='Price'
                { ...this.getFieldParameters('price') }
            />
        );

        const priceSPField = this.getField(
            <input
                type='text'
                label='SP Price'
                { ...this.getFieldParameters('spPrice')}
            />
        );

        const winReductionField = this.getField(
            <input
                type='text'
                label='Win Red.'
                { ...this.getFieldParameters('winReduction') }
            />
        );

        const placeReductionField = this.getField(
            <input
                type='text'
                label='Place Red.'
                { ...this.getFieldParameters('placeReduction') }
            />
        );

        const eachWayReductionField = this.getField(
            <input
                type='text'
                label='E/W Red.'
                { ...this.getFieldParameters('eachWayReduction') }
            />
        );

        const r4DeductionsField = this.getField(
            <select
                type='text'
                label='R4'
                { ...this.getFieldParameters('r4Deductions') }
            >
                <option value='0'>No</option>
                { range(5, 100, 5).map(x => <option key={ x } value={ x }>{ x }p</option>) }
            </select>
        );

        const selectionName = data.selection && data.selection.name;
        const hasBonuses = bonuses.length > 0;
        const bonus = hasBonuses ?
            (<div className='col-4 bonuses'>
                {
                    bonuses.map(bonus => {
                        // Find current bonus type in the list with all Bonuses
                        const bonusName = bonusList.find(bonusItem => bonusItem.get('type') === bonus.type );

                        return (
                            <p> { bonusName ? bonusName.get('name') : bonus.type }  Bonus: { money(bonus.amount || 0, currency) }</p>
                        );
                    })
                }
            </div>) : void 0;

        if (this.state.data.type === 'place') {
            if (eachWay) {
                return (
                    <div className='leg-result-form'>
                        <div className='row'>
                            <div className={ hasBonuses ? 'col-2 leg-result-form__name' : 'col-3 leg-result-form__name'} title={ selectionName }>
                                { selectionName }
                            </div>
                            { bonus }
                            <div className='result-options col-1'>
                                { resultField }
                            </div>
                            <div className='col-1'>
                                { placeField }
                            </div>
                            <div className='col-1'>
                                { priceTypeField }
                            </div>
                            <div className='col-1'>
                                { priceField }
                            </div>
                            <div className='col-1'>
                                { priceSPField }
                            </div>
                            <div className='col-1'>
                                { winReductionField }
                            </div>
                            {
                                !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                                    <div className='col-1'>
                                        { placeReductionField }
                                    </div> : void 0
                            }
                            <div className='col-1'>
                                { eachWayReductionField }
                            </div>
                            { !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                                <div className='col-1'>
                                    { r4DeductionsField }
                                </div> : void 0
                            }
                        </div>
                    </div>
                );
            }

            return (
                <div className='leg-result-form'>
                    <div className='row'>
                        <div className={ hasBonuses ? 'col-2 leg-result-form__name' : 'col-4 leg-result-form__name'} title={ selectionName }>
                            { selectionName }
                        </div>
                        { bonus }
                        <div className='result-options col-1'>
                            { resultField }
                        </div>
                        <div className='col-1'>
                            { placeField }
                        </div>
                        <div className='col-1'>
                            { priceTypeField }
                        </div>
                        <div className='col-1'>
                            { priceField }
                        </div>
                        <div className='col-1'>
                            { priceSPField }
                        </div>
                        <div className='col-1'>
                            { winReductionField }
                        </div>
                        {
                            !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                                <div className='col-1'>
                                    { placeReductionField }
                                </div> : void 0
                        }
                        { !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                            <div className='col-1'>
                                { r4DeductionsField }
                            </div> : void 0
                        }
                    </div>
                </div>
            );
        }

        if (eachWay) {
            return (
                <div className='leg-result-form'>
                    <div className='row'>
                        <div className={ hasBonuses ? 'col-2 leg-result-form__name' : 'col-4 leg-result-form__name'} title={ selectionName }>
                            { selectionName }
                        </div>
                        { bonus }
                        <div className='result-options col-1'>
                            { resultField }
                        </div>
                        <div className='col-1'>
                            { priceTypeField }
                        </div>
                        <div className='col-1'>
                            { priceField }
                        </div>
                        <div className='col-1'>
                            { priceSPField }
                        </div>
                        <div className='col-1'>
                            { winReductionField }
                        </div>
                        {
                            !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                                <div className='col-1'>
                                    { placeReductionField }
                                </div> : void 0
                        }
                        <div className='col-1'>
                            { eachWayReductionField }
                        </div>
                        { !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                            <div className='col-1'>
                                { r4DeductionsField }
                            </div> : void 0
                        }
                    </div>
                </div>
            );
        }

        return (
            <div className='leg-result-form'>
                <div className='row'>
                    <div className={ hasBonuses ? 'col-2 leg-result-form__name' : 'col-4 leg-result-form__name'} title={ selectionName }>
                        { selectionName }
                    </div>
                    { bonus }
                    <div className='result-options col-1'>
                        { resultField }
                    </div>
                    <div className='col-1'>
                        { priceTypeField }
                    </div>
                    <div className='col-1'>
                        { priceField }
                    </div>
                    <div className='col-1'>
                        { priceSPField }
                    </div>
                    <div className='col-1'>
                        { winReductionField }
                    </div>
                    {
                        !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                            <div className='col-1'>
                                { placeReductionField }
                            </div> : void 0
                    }
                    { !data.sport || data.sport.id === 'horseracing' || data.sport.id === 'internationalhorseracing' ?
                        <div className='col-1'>
                            { r4DeductionsField }
                        </div> : void 0
                    }
                </div>
            </div>
        );
    }
}

export default LegResultForm;
